const nestedItem = "_275n1nfyhk0";
const nestedRowSizingCls = "_275n1t8ed1j";
const statsCls = "_275sxkv1cr";
const mobileHeadingCls = "_275m1yzuy7f";
const mobileStatsCell = "_275m13fhkz8";
const mobileDialogCell = "_275map5po0";

export { mobileDialogCell, mobileHeadingCls, mobileStatsCell, nestedItem, nestedRowSizingCls, statsCls };
import "./table.nested-item.style.linaria.module.css";
//# sourceMappingURL=table.nested-item.style.js.map
